import Modal from "common/Modal/Modal";
import CreateOrEditStep from "features/affiliation/ReferralLinks/CreateLink/CreateOrEditStep";
import { affiliationService } from "app/services/affiliation.service";
import Button from "common/Buttons/Button";
import {
  CreateReferralLinkRequest,
  ReferralLink,
} from "types/affiliation.types";
import { displayResultMessage } from "utils/misc";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

interface EditLinkModalProps {
  isVisible: boolean;
  closeModal: () => void;
  referralLink: ReferralLink;
}

const EditLinkModal = ({
  isVisible,
  closeModal,
  referralLink,
}: EditLinkModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);
  const [editReferralLink, { isLoading: editLoading }] =
    affiliationService.useEditReferralLinkMutation();

  const editReferralLinkHandler = (values: CreateReferralLinkRequest) => {
    return displayResultMessage(
      editReferralLink({
        referral_id: referralLink.referral_id,
        description: values.description || "",
      }).unwrap(),
      t("links.updated_success"),
      t("links.update_error"),
      undefined,
      () => closeModal()
    );
  };

  const footer = [
    <Button key="cancel" onClick={closeModal}>
      {t("common.cancel")}
    </Button>,
    <Button
      key="create"
      type="primary"
      htmlType="submit"
      form="createLinkForm"
      loading={editLoading}
    >
      {t("common.update")}
    </Button>,
  ];

  return (
    <Modal
      onCancel={closeModal}
      open={isVisible}
      title={t("links.edit_link")}
      footer={footer}
      destroyOnHidden={true}
    >
      <CreateOrEditStep
        isEdit={true}
        referralCode={referralLink.referral_code}
        description={referralLink.description}
        onSubmit={editReferralLinkHandler}
      />
    </Modal>
  );
};

export default EditLinkModal;
